// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/loanhistoryconsts.proto (package aurora.core.consts.contracthistory, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/loanhistoryconsts.proto.
 */
export const file_consts_loanhistoryconsts: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from enum aurora.core.consts.contracthistory.ContractHistoryEventType
 */
export enum ContractHistoryEventType {
  /**
   * @generated from enum value: UNSPECIFIED_CONTRACT_HISTORY_EVENT_TYPE = 0;
   */
  UNSPECIFIED_CONTRACT_HISTORY_EVENT_TYPE = 0,

  /**
   * Initial creation of the loan
   *
   * @generated from enum value: CREATED = 1;
   */
  CREATED = 1,

  /**
   * Pending settlement
   *
   * @generated from enum value: PENDING = 2;
   */
  PENDING = 2,

  /**
   * Cancel operation pending
   *
   * @generated from enum value: CANCEL_PENDING = 3;
   */
  CANCEL_PENDING = 3,

  /**
   * Deliver Order pending settlement
   *
   * @generated from enum value: DO_PENDING = 4;
   */
  DO_PENDING = 4,

  /**
   * Loan made (DO Made)
   *
   * @generated from enum value: MADE = 5;
   */
  MADE = 5,

  /**
   * Pending Loan dropped at EOD
   *
   * @generated from enum value: DROPPED = 6;
   */
  DROPPED = 6,

  /**
   * Pending Loan rejected (usually by settlement system)
   *
   * @generated from enum value: REJECTED = 7;
   */
  REJECTED = 7,

  /**
   * Cancel operation rejected (usually by settlement system)
   *
   * @generated from enum value: CANCEL_REJECTED = 8;
   */
  CANCEL_REJECTED = 8,

  /**
   * Pending loan successfully cancelled
   *
   * @generated from enum value: CANCELLED = 9;
   */
  CANCELLED = 9,

  /**
   * Recalled (can be partial)
   *
   * @generated from enum value: RECALLED = 10;
   */
  RECALLED = 10,

  /**
   * Recall rejected (usually by settlement system)
   *
   * @generated from enum value: RECALL_REJECTED = 11;
   */
  RECALL_REJECTED = 11,

  /**
   * Open recall cancelled
   *
   * @generated from enum value: RECALL_CANCELED = 12;
   */
  RECALL_CANCELED = 12,

  /**
   * Rolled to the next day (SFT mark-to-market)
   *
   * @generated from enum value: ROLLED = 13;
   */
  ROLLED = 13,

  /**
   * Roll pending at DTCC
   *
   * @generated from enum value: ROLL_PENDING = 14;
   */
  ROLL_PENDING = 14,

  /**
   * Roll price differential pending
   *
   * @generated from enum value: ROLL_PD_PENDING = 15;
   */
  ROLL_PD_PENDING = 15,

  /**
   * Roll price differential made
   *
   * @generated from enum value: ROLL_PD_MADE = 16;
   */
  ROLL_PD_MADE = 16,

  /**
   * Returned (fully)
   *
   * @generated from enum value: RETURNED = 17;
   */
  RETURNED = 17,

  /**
   * Return pending (can be partial)
   *
   * @generated from enum value: RETURN_PENDING = 18;
   */
  RETURN_PENDING = 18,

  /**
   * Partially returned
   *
   * @generated from enum value: PARTIALLY_RETURNED = 19;
   */
  PARTIALLY_RETURNED = 19,

  /**
   * Return successfully cancelled
   *
   * @generated from enum value: RETURN_CANCELED = 20;
   */
  RETURN_CANCELED = 20,

  /**
   * Return failed (ie. dropped at EOD)
   *
   * @generated from enum value: RETURN_FAILED = 21;
   */
  RETURN_FAILED = 21,

  /**
   * Return return rejected (usually by settlement system)
   *
   * @generated from enum value: RETURN_REJECTED = 22;
   */
  RETURN_REJECTED = 22,

  /**
   * Terminated
   *
   * @generated from enum value: TERMINATED = 23;
   */
  TERMINATED = 23,

  /**
   * Buy-in completed (can be partial)
   *
   * @generated from enum value: BUY_IN = 24;
   */
  BUY_IN = 24,

  /**
   * Buy-in pending
   *
   * @generated from enum value: BUY_IN_PENDING = 25;
   */
  BUY_IN_PENDING = 25,

  /**
   * Buy-in cancelled
   *
   * @generated from enum value: BUY_IN_CANCELLED = 26;
   */
  BUY_IN_CANCELLED = 26,

  /**
   * Buy-in rejected (usually by settlement system)
   *
   * @generated from enum value: BUY_IN_REJECTED = 27;
   */
  BUY_IN_REJECTED = 27,

  /**
   * Buy-in payment order made
   *
   * @generated from enum value: BUY_IN_PO_MADE = 28;
   */
  BUY_IN_PO_MADE = 28,

  /**
   * Buy-in payment order failed
   *
   * @generated from enum value: BUY_IN_PO_FAILED = 29;
   */
  BUY_IN_PO_FAILED = 29,

  /**
   * Rate successfully renegotiated
   *
   * @generated from enum value: RENEGOTIATED = 30;
   */
  RENEGOTIATED = 30,

  /**
   * Rate renegotiation cancelled
   *
   * @generated from enum value: RENEGOTIATION_CANCELED = 31;
   */
  RENEGOTIATION_CANCELED = 31,

  /**
   * Rate renegotiation rejected
   *
   * @generated from enum value: RENEGOTIATION_REJECTED = 32;
   */
  RENEGOTIATION_REJECTED = 32,

  /**
   * Rate renegotiation expired
   *
   * @generated from enum value: RENEGOTIATION_EXPIRED = 33;
   */
  RENEGOTIATION_EXPIRED = 33,

  /**
   * Undergoing corporate action
   *
   * @generated from enum value: CORPORATE_ACTION = 34;
   */
  CORPORATE_ACTION = 34,

  /**
   * Marked to market
   *
   * @generated from enum value: MARKED_TO_MARKET = 35;
   */
  MARKED_TO_MARKET = 35,

  /**
   * Mark to market payment order failed
   *
   * @generated from enum value: MARK_TO_MARKET_PO_FAILED = 36;
   */
  MARK_TO_MARKET_PO_FAILED = 36,

  /**
   * Mark to market payment order made
   *
   * @generated from enum value: MARK_TO_MARKET_PO_MADE = 37;
   */
  MARK_TO_MARKET_PO_MADE = 37,

  /**
   * Daily interest amount
   *
   * @generated from enum value: DAILY_INTEREST_AMOUNT = 38;
   */
  DAILY_INTEREST_AMOUNT = 38,

  /**
   * Daily interest payment order failed
   *
   * @generated from enum value: DAILY_INTEREST_PO_FAILED = 39;
   */
  DAILY_INTEREST_PO_FAILED = 39,

  /**
   * Daily interest payment order made
   *
   * @generated from enum value: DAILY_INTEREST_PO_MADE = 40;
   */
  DAILY_INTEREST_PO_MADE = 40,

  /**
   * Floating rate recalculated
   *
   * @generated from enum value: FLOATING_RATE_RECALCULATED = 41;
   */
  FLOATING_RATE_RECALCULATED = 41,

  /**
   * Return proposed (after cut-off set by lender)
   *
   * @generated from enum value: RETURN_PROPOSED = 42;
   */
  RETURN_PROPOSED = 42,

  /**
   * Return proposal accepted by lender
   *
   * @generated from enum value: RETURN_PROPOSAL_ACCEPTED = 43;
   */
  RETURN_PROPOSAL_ACCEPTED = 43,

  /**
   * Return proposal rejected by lender
   *
   * @generated from enum value: RETURN_PROPOSAL_REJECTED = 44;
   */
  RETURN_PROPOSAL_REJECTED = 44,

  /**
   * Return proposal cancelled by borrower
   *
   * @generated from enum value: RETURN_PROPOSAL_CANCELED = 45;
   */
  RETURN_PROPOSAL_CANCELED = 45,

  /**
   * Return proposal dropped at EOD
   *
   * @generated from enum value: RETURN_PROPOSAL_DROPPED = 46;
   */
  RETURN_PROPOSAL_DROPPED = 46,

  /**
   * Return cancel request rejected by DTCC
   *
   * @generated from enum value: RETURN_CANCEL_REJECTED = 47;
   */
  RETURN_CANCEL_REJECTED = 47,
}

/**
 * Describes the enum aurora.core.consts.contracthistory.ContractHistoryEventType.
 */
export const ContractHistoryEventTypeSchema: GenEnum<ContractHistoryEventType> = /*@__PURE__*/
  enumDesc(file_consts_loanhistoryconsts, 0);

/**
 * @generated from enum aurora.core.consts.contracthistory.ContractHistoryEventInitiatorKind
 */
export enum ContractHistoryEventInitiatorKind {
  /**
   * @generated from enum value: UNSPECIFIED_EVENT_INITIATOR_KIND = 0;
   */
  UNSPECIFIED_EVENT_INITIATOR_KIND = 0,

  /**
   * Unknown
   *
   * @generated from enum value: UNKNOWN = 1;
   */
  UNKNOWN = 1,

  /**
   * Aurora system
   *
   * @generated from enum value: SYSTEM = 2;
   */
  SYSTEM = 2,

  /**
   * Bot user
   *
   * @generated from enum value: BOT = 3;
   */
  BOT = 3,

  /**
   * Trader user
   *
   * @generated from enum value: TRADER = 4;
   */
  TRADER = 4,

  /**
   * Counterparty
   *
   * @generated from enum value: CONTRA = 5;
   */
  CONTRA = 5,
}

/**
 * Describes the enum aurora.core.consts.contracthistory.ContractHistoryEventInitiatorKind.
 */
export const ContractHistoryEventInitiatorKindSchema: GenEnum<ContractHistoryEventInitiatorKind> = /*@__PURE__*/
  enumDesc(file_consts_loanhistoryconsts, 1);

/**
 * @generated from enum aurora.core.consts.contracthistory.ContractHistorySortableField
 */
export enum ContractHistorySortableField {
  /**
   * @generated from enum value: UNSPECIFIED_CONTRACT_HISTORY_SORTABLE_FIELD = 0;
   */
  UNSPECIFIED_CONTRACT_HISTORY_SORTABLE_FIELD = 0,

  /**
   * Event type
   *
   * @generated from enum value: EVENT_TYPE = 1;
   */
  EVENT_TYPE = 1,

  /**
   * Event timestamp
   *
   * @generated from enum value: EVENT_TIME = 2;
   */
  EVENT_TIME = 2,

  /**
   * Open quantity
   *
   * @generated from enum value: OPEN_QUANTITY = 3;
   */
  OPEN_QUANTITY = 3,

  /**
   * Counterparty
   *
   * @generated from enum value: COUNTERPARTY = 4;
   */
  COUNTERPARTY = 4,

  /**
   * Ticker
   *
   * @generated from enum value: INSTRUMENT_TICKER = 5;
   */
  INSTRUMENT_TICKER = 5,

  /**
   * Cusip
   *
   * @generated from enum value: INSTRUMENT_CUSIP = 6;
   */
  INSTRUMENT_CUSIP = 6,

  /**
   * Rate
   *
   * @generated from enum value: RATE = 7;
   */
  RATE = 7,

  /**
   * Daily interest amount
   *
   * @generated from enum value: RATE_AMOUNT = 8;
   */
  RATE_AMOUNT = 8,

  /**
   * Settlement amount
   *
   * @generated from enum value: SETTLEMENT_AMOUNT = 9;
   */
  SETTLEMENT_AMOUNT = 9,

  /**
   * Settlement type
   *
   * @generated from enum value: SETTLEMENT_TYPE = 10;
   */
  SETTLEMENT_TYPE = 10,

  /**
   * Settlement amount change
   *
   * @generated from enum value: SETTLEMENT_AMOUNT_CHANGE = 11;
   */
  SETTLEMENT_AMOUNT_CHANGE = 11,

  /**
   * Open quantity change
   *
   * @generated from enum value: OPEN_QUANTITY_CHANGE = 12;
   */
  OPEN_QUANTITY_CHANGE = 12,

  /**
   * Event initiator
   *
   * @generated from enum value: INITIATOR = 13;
   */
  INITIATOR = 13,

  /**
   * Side of the loan
   *
   * @generated from enum value: SIDE = 14;
   */
  SIDE = 14,

  /**
   * Settlement date
   *
   * @generated from enum value: SETTLEMENT_DATE = 15;
   */
  SETTLEMENT_DATE = 15,
}

/**
 * Describes the enum aurora.core.consts.contracthistory.ContractHistorySortableField.
 */
export const ContractHistorySortableFieldSchema: GenEnum<ContractHistorySortableField> = /*@__PURE__*/
  enumDesc(file_consts_loanhistoryconsts, 2);

